module.exports = __webpack_public_path__ + "img/shop-icon.8953fb60.png";